import styled from 'styled-components';

import { useModalContext } from 'utils/contexts/modal';
import { SecondaryButton, GhostButton, PrimaryButton } from 'ui/button';
import { useAdAccountContext } from '../../contexts/AdAccountContext';
import { FacebookModalState } from '../../domain/modal';
import { useFbcaTranslations } from '../../hooks/useTranslations';

const PageActionWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  column-gap: ${({ theme }) => theme.spacing.values.threeEights};
`;

const HelperText = styled.div`
  color: ${({ theme }) => theme.colors.textColors.textSecondary};
  font-size: ${({ theme }) => theme.styles.fontSizes.s18};
`;

export const AdAccountHeaderPageActions = () => {
  const { allAdAccountIds, selectAllAdAccounts, clearAllAdAccounts, adAccountIds } =
    useAdAccountContext();
  const { t } = useFbcaTranslations();
  const { showModal } = useModalContext<FacebookModalState>();
  const buttonEnabled = adAccountIds.length > 0;
  const selectAllButtonEnabled = adAccountIds.length !== allAdAccountIds.length;
  const helperText = buttonEnabled
    ? t('pageActions.helperText', { adAccounts: adAccountIds.length })
    : t('pageActions.helperTextEmpty');

  return (
    <PageActionWrapper>
      <HelperText>{helperText}</HelperText>
      {buttonEnabled && (
        <GhostButton onClick={clearAllAdAccounts}>{t('pageActions.clear')}</GhostButton>
      )}
      {selectAllButtonEnabled && (
        <SecondaryButton onClick={selectAllAdAccounts}>
          {t('pageActions.selectAll')}
        </SecondaryButton>
      )}
      <PrimaryButton isDisabled={!buttonEnabled} onClick={() => showModal({ adAccountIds })}>
        {t('pageActions.connect')}
      </PrimaryButton>
    </PageActionWrapper>
  );
};
